import { bindActionCreators } from 'redux';

export const SAVE_USER = 'USER/SAVE_USER';
export const DONE_USER = 'USER/DONE_USER';
export const LOGOUT_USER = 'USER/LOGOUT_USER';
export const GET_PROGRESS = 'USER/GET_PROGRESS';
export const SAVE_PROGRESS = 'USER/SAVE_PROGRESS';
export const REMOVE_USER = 'USER/REMOVE_USER';
export const UPDATE_USER = 'USER/UPDATE_USER';

export const saveUser = (user = {}) => ({
  type: SAVE_USER,
  payload: { user }
});

export const registrationDone = () => ({
  type: DONE_USER
});

export const logout = () => ({
  type: LOGOUT_USER
});

export const resetStore = (fullReset = false) => ({
  type: 'RESET_STORE',
  payload: { fullReset }
});

export const getUserProgress = cb => ({
  type: GET_PROGRESS,
  payload: { cb }
});


const saveUserProgress = lastRoute => ({
  type: SAVE_PROGRESS,
  payload: { lastRoute }
});

export const updateUser = () => ({
  type: UPDATE_USER
});

export const removeUser = () => ({
  type: REMOVE_USER
});

function containerActions(dispatch) {
  return bindActionCreators(
    {
      resetStore,
      getUserProgress,
      saveUserProgress,
      logout,
      removeUser
    },
    dispatch
  );
}

export default containerActions;



// WEBPACK FOOTER //
// ./src/pages/Login/actions.js